import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { isEmpty } from 'lodash-es'

import { useGetInviteeQuery, useGetRescheduledInviteeQuery } from 'root-api'
import { currentInviteeSelector } from 'selectors/current_invitee'
import { legacyInviteeSelector } from 'selectors/invitee'

export const useInvitee = () => {
  const { params } = useRouteMatch()
  const [rescheduledUuid, setRescheduledUuid] = useState()
  // This is a workaround for the legacy invitee data
  // DO NOT USE "inviteeSelector" here because it will cause an issue with RTK query refetching
  // and the invitee cache data will unsubscribed due to the skip condition
  const legacyInviteeData = useSelector(legacyInviteeSelector) // Grab only Redux legacy invitee data
  const currentInvite = useSelector(currentInviteeSelector) // Grab only RTK query invitee data

  const {
    isLoading,
    isError
  } = useGetInviteeQuery(
    { uuid: params.inviteeUuid },
    { skip: legacyInviteeData?.uuid || !params.inviteeUuid }
  )

  const {
    isLoading: isRescheduledLoading,
    isError: isRescheduledError,
  } = useGetRescheduledInviteeQuery(
    { uuid: rescheduledUuid },
    { skip: !rescheduledUuid }
  )

  useEffect(() => {
    if (legacyInviteeData?.rescheduled) {
      setRescheduledUuid(legacyInviteeData.new_invitee_uuid)
    } else if (currentInvite?.rescheduled) {
      setRescheduledUuid(currentInvite.new_invitee_uuid)
    }
  }, [legacyInviteeData, currentInvite, setRescheduledUuid])

  if (isLoading || isRescheduledLoading) return undefined
  if (isError || isRescheduledError) return null
  // This return is actually works as "inviteeSelector"
  // and will omit the refetch of the invitee data
  return isEmpty(currentInvite) ? legacyInviteeData : currentInvite
}
